
<section class="container-fluid sts-section">

    <app-sts-section-header key="sts-verify-otc"  [errors]="errors">
      Verify One Time Code
      <app-sts-section-header-side>
        <div class="text-right"><a
          routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
        </div>
      </app-sts-section-header-side>
    </app-sts-section-header>

    <app-sts-section-body key="sts-verify-otc-body-section">
      We have sent a Welcome letter to the address you have on file. Please enter the One Time Code sent to you in the provided field below.
    </app-sts-section-body>


    <form #form="ngForm"
          (ngSubmit)="onSubmitCode()"
          [formGroup]="frmOtc"
          class="sts-form" autocomplete="off">

      <div class="row sts-form-row">
        <div class="col-24">

          <!-- -->
          <div class="sts-object">

            <div>
              <label app-sts-cms-txt key="sts-pick-one-time-code" for="sts_one_time_code">
                One Time Code:
              </label>
              <input type="text"
                     id="sts_one_time_code"
                     name="sts_one_time_code"
                     formControlName="code"
                     maxlength="100"
                     [ngClass]="{'has-errors' : isInvalidCode() }"
                     class="sts-textbox" >
              <div class="text-danger" *ngIf="frmOtc.controls['code'].invalid && (frmOtc.controls['code'].dirty || frmOtc.controls['code'].touched)">
                <div app-sts-cms-txt key="sts-otc-is-valid-required" *ngIf="frmOtc.controls['code'].errors['required']">A valid code is required</div>
              </div>
              <p>&nbsp;</p>

            </div>


          </div>
          <!-- -->


        </div>
      </div>

      <div class="row">
        <div class="col-24">

          <!-- -->
          <div class="sts-object">
            <button app-sts-cms-txt key="sts-cancel-button"
                    class="sts-btn other-sts-btn"
                    type="button"
                    (click)="gotoHome()">
              Cancel
            </button>

            <app-sts-button [submit]="submitter"  [disabled]="isRunOfAttempt"
                            key="sts-next-button">
              Next
            </app-sts-button>
          </div>
          <!-- -->

        </div>
      </div>

    </form>


  </section>


